import * as React from 'react';
import { memo } from 'react';

const SvgTrash3 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.188 4.571H2.812M7.313 7.946v4.5M10.688 7.946v4.5M14.063 4.571V15.26a.562.562 0 0 1-.563.562h-9a.563.563 0 0 1-.563-.562V4.57", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M11.813 4.571V3.446a1.125 1.125 0 0 0-1.126-1.125H7.313a1.125 1.125 0 0 0-1.125 1.125v1.125", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgTrash3);

export { Memo as default };
